import { render, staticRenderFns } from "./SourceDetails.vue?vue&type=template&id=c7231e10&scoped=true&"
import script from "./SourceDetails.vue?vue&type=script&lang=js&"
export * from "./SourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./SourceDetails.vue?vue&type=style&index=0&id=c7231e10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7231e10",
  null
  
)

export default component.exports